module.exports = __webpack_public_path__ + "static/media/youwin.f701ceb2.jpg";